import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { ReactNode, createContext, useContext, useState } from "react";
import DeviceHistoryModal from "@/components/grid/rowDetail/DeviceHistoryModal";
import { CreateMaintenanceOrderDialog } from "@/components/maintenance/CreateMaintenanceOrderDialog";
import DetailsModal from "@/pages/diagnosticmonitor/components/DetailsModal";
import MaintenanceModal from "@/pages/diagnosticmonitor/components/MaintenanceModal";
import TellTaleModal from "@/pages/diagnosticmonitor/components/TellTaleModal";

interface ModalContextProps {
  open: boolean;
  data: GridRenderCellParams | null;
  openModal: (data: any, type: ModalType) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);
export enum ModalType {
  DIAGNOSTIC_DETAILS,
  MAINTENANCE_DETAILS,
  TELLTALE_DETAILS,
  DEVICE_HISTORY,
  CREATE_PM_ORDER,
}
export function ModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  const [modalType, setModalType] = useState<ModalType | null>(null);

  const openModal = (data: any, type: ModalType) => {
    setModalType(type);
    setModalData(data);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setModalData(null);
  };

  return (
    <ModalContext.Provider value={{ open, data: modalData, openModal, closeModal }}>
      {children}
      {modalType === ModalType.DIAGNOSTIC_DETAILS && (
        <DetailsModal open={open} handleClose={closeModal} modalData={modalData} />
      )}
      {modalType === ModalType.MAINTENANCE_DETAILS && (
        <MaintenanceModal open={open} handleClose={closeModal} modalData={modalData} />
      )}
      {modalType === ModalType.TELLTALE_DETAILS && (
        <TellTaleModal open={open} handleClose={closeModal} modalData={modalData} />
      )}
      {modalType === ModalType.DEVICE_HISTORY && (
        <DeviceHistoryModal open={open} handleClose={closeModal} deviceId={modalData} />
      )}
      {modalType === ModalType.CREATE_PM_ORDER && modalData && (
        <CreateMaintenanceOrderDialog
          open={open}
          device={modalData.device}
          warning={modalData.warning}
          ruleAddinData={modalData.ruleAddinData}
          onClose={closeModal}
        />
      )}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
}
